import { render } from "./AwardDetailSept2022Page.vue?vue&type=template&id=77874c09"
import script from "./AwardDetailSept2022Page.vue?vue&type=script&lang=js"
export * from "./AwardDetailSept2022Page.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__